exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InlineTooltip-hashed__inlineTooltip__3i_qH{--inlineTooltip-margin-x: var(--GW-SPACING);--inlineTooltip-margin-y: var(--GW-SPACING-XS);--inlineTooltip-link-color: var(--GW-COLOR-PRIMARY);--inlineTooltip-icon-padding: var(--GW-SPACING-XS);--inlineTooltip-font-weight: var(--GW-FONT-WEIGHT-300);margin-left:var(--inlineTooltip-margin-x);margin-top:var(--inlineTooltip-margin-y);display:flex;flex-direction:column;width:100%}.InlineTooltip-hashed__link__2wfm8{color:var(--inlineTooltip-link-color)}.InlineTooltip-hashed__icon__Zgku_{padding-left:var(--inlineTooltip-icon-padding)}.InlineTooltip-hashed__text__mWuSt{font-weight:var(--inlineTooltip-font-weight);margin:0}\n", ""]);

// exports
exports.locals = {
	"inlineTooltip": "InlineTooltip-hashed__inlineTooltip__3i_qH",
	"link": "InlineTooltip-hashed__link__2wfm8",
	"icon": "InlineTooltip-hashed__icon__Zgku_",
	"text": "InlineTooltip-hashed__text__mWuSt"
};